import { render, staticRenderFns } from "./MenuReview.vue?vue&type=template&id=2bfa2f2c&"
import script from "./MenuReview.vue?vue&type=script&lang=js&"
export * from "./MenuReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports